var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"panel",staticClass:"color-panel",style:({
    background: _vm.image?`url(${_vm.image}) no-repeat 0 0 / 100% 100%`: ''
  })},[_c('div',{staticClass:"cursor",style:({top:_vm.cursorTop + 'px',left:_vm.cursorLeft +'px'})},[_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }